'use strict';
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
var food = {
    Drink: {
        Wine: {},
        Schnaps: {}
    },
    Fruit: {
        Red: {
            Cherry: {},
            Strawberry: {}
        },
        Yellow: {
            Banana: {},
            Pineapple: {}
        }
    }
};
function createTree(element, data) {
    if (!element || typeof element.append !== 'function') throw new Error('Invalid DOM element provided to createTree');
    if ((typeof data === "undefined" ? "undefined" : _type_of(data)) !== 'object' || data === null || Array.isArray(data)) return;
    var keys = Object.keys(data);
    if (keys.length === 0) return; // не создаём пустой <ul>
    var ul = document.createElement('ul');
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = keys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var key = _step.value;
            var li = document.createElement('li');
            li.textContent = key;
            var value = data[key];
            if ((typeof value === "undefined" ? "undefined" : _type_of(value)) === 'object' && value !== null && !Array.isArray(value) && Object.keys(value).length > 0) createTree(li, value);
            ul.append(li);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    element.append(ul);
}
if (typeof document !== 'undefined') {
    var tree = document.querySelector('#tree');
    if (tree) createTree(tree, food);
}
if (typeof module !== 'undefined' && module.exports) module.exports = {
    createTree: createTree
};

//# sourceMappingURL=js_tree-from-object-DOM.86014bc1.js.map
